import clsx from 'clsx';
import { InHandDateDisplay } from 'src/components/common/InHandDateDisplay';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { isMustShipByBeforeInHand } from 'src/utils/saleUtils';
import { Feature } from 'src/WebApiController';

import { inHandMustShipByCellBackground } from './InHandCell.css';

export type InHandCellProps = {
  date: Date | null;
  needsToFulfill?: boolean;
  handleFulfillmentState?: boolean;
  mustShipByDate?: Date | null;
};

export const InHandCell = ({
  date,
  needsToFulfill,
  handleFulfillmentState,
  mustShipByDate,
}: InHandCellProps) => {
  const ihdTimezoneFix = useUserHasFeature(Feature.IhdTimezoneFix);
  const msbdDisplayEnabled = useUserHasFeature(Feature.MustShipByDateDisplay);
  const effectiveMustShipByDate = msbdDisplayEnabled ? mustShipByDate : null;

  return (
    <InHandDateDisplay
      date={date}
      needsToFulfill={needsToFulfill}
      handleFulfillmentState={handleFulfillmentState}
      mustShipByDate={effectiveMustShipByDate}
      showAbsoluteDate={true}
      className={clsx({
        [inHandMustShipByCellBackground]: isMustShipByBeforeInHand(
          date,
          effectiveMustShipByDate,
          ihdTimezoneFix
        ),
      })}
    />
  );
};
